<ng-container *ngIf="isMelodyPaid() else freeMelody">
  <ng-container *ngIf="!showGiftChoice else giftChoiceTemplate">
    <div class="modal modal_pb_40 modal__opened">
      <div class="modal__close icon icon-close" (click)="close()"></div>
      <div class="modal__container">
        <div class="modal__title modal__title-mb16 h2">{{ 'gift-modal.title' | translate }}</div>
        <div class="modal__subtitle">{{ 'gift-modal.subtitle' | translate }}</div>
        <div class="modal__content">
          <div class="modal__form-field">
            <div class="input input_width_auto" [class.input_type_error]="msisdnError?.length > 0">
              <label class="input__label">{{ 'gift-modal.msisdn-label' | translate }}</label>
              <div class="input__container">
                <input type="text" [placeholder]="'gift-modal.msisdn-mask' | translate" class="input__input phone-mask"
                       [(ngModel)]="msisdn"
                       mask="+0 000 000-00-00" (ngModelChange)="msisdnChanged()" (keyup.enter)="chooseMelody()"
                       (keyup.shift.enter)="chooseMelody()"/>
              </div>
            </div>
            <div class="input__error" *ngIf="msisdnError?.length > 0">{{ msisdnError | translate }}</div>
          </div>
        </div>
      </div>
      <div class="modal__buttons-row">
        <div class="button"
             [class.button_status_disabled]="msisdn.length < 11"
             [class.button_type_load]="requestInProgress"
             [class.with-icon]="requestInProgress"
             (click)="chooseMelody()">{{ 'gift-modal.gift' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #giftChoiceTemplate>
  <ng-container *ngIf="!giftSuccess else giftSent">
    <div class="modal modal_size_744 modal__opened">
      <div class="modal__close icon icon-close" (click)="close()"></div>
      <div class="modal__container">
        <div class="modal__title modal__title-mb24 h2">{{ 'gift-modal.subscription-choose-title' | translate }}</div>
        <div class="modal__content">
          <div class="modal__plan" *ngIf="!privet">
            <div class="modal-plan modal-plan_type_recommended"
                 [class.modal-plan_type_selected]="privetPlusPurchase"
                 (click)="togglePlan(true)">
              <div class="modal-plan__recommended" [innerHTML]="'gift-modal.recommendation' | translate"></div>
              <div class="modal-plan__title" [innerHTML]="'gift-modal.try-privet-plus-title' | translate"></div>
              <div class="modal-plan__text" [innerHTML]="'gift-modal.try-privet-plus-text' | translate"></div>
            </div>
          </div>
          <div class="modal__plan" *ngIf="!privetPlus">
            <div class="modal-plan"
                 [class.modal-plan_type_selected]="!privetPlusPurchase"
                 (click)="togglePlan(false)">
              <div class="modal-plan__title" [innerHTML]="'gift-modal.without-privet-plus-title' | translate"></div>
              <div class="modal-plan__text" [innerHTML]="'gift-modal.without-privet-plus-text' | translate"></div>
            </div>
          </div>
        </div>
        <div class="input__error" *ngIf="msisdnError?.length > 0">{{ msisdnError | translate }}</div>
      </div>
      <div class="modal__buttons-row modal__buttons-mt40">
        <div class="button"
             [class.button_type_load]="requestInProgress"
             [class.with-icon]="requestInProgress"
             (click)="giftMelody()">{{ 'gift-modal.gift' | translate }}</div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #giftSent>
  <div class="modal modal_pb_40 modal__opened">
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2">{{ 'gift-modal.gift-sent-title' | translate }}</div>
      <div
        class="modal__text">{{ 'gift-modal.gift-sent-text' | translate: {msisdn: msisdn | mask: '+0 000 000-00-00'} }}
      </div>
      <div class="modal__text" *ngIf="!privetPlusPurchase&& !privet">{{ 'gift-modal.gift-sent-text-additional' | translate: {msisdn: msisdn | mask: '+0 000 000-00-00'} }}</div>
      <div class="modal__text" *ngIf="privetPlusPurchase && !privetPlus">{{ 'gift-modal.gift-sent-text-additional-pro' | translate: {msisdn: msisdn | mask: '+0 000 000-00-00'} }}</div>
      <div class="modal__text">{{ 'gift-modal.gift-sent-text-info' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'gift-modal.ok-button' | translate }}</div>
    </div>
  </div>
</ng-template>

<ng-template #freeMelody>
  <div class="modal modal_pb_40 modal__opened">
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_whistling modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2">{{ 'gift-modal.gift-free-melody-title' | translate }}</div>
      <div
        class="modal__text">{{ 'gift-modal.gift-free-melody-text' | translate: {msisdn: msisdn | mask: '+0 000 000-00-00'} }}
      </div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'gift-modal.ok-button' | translate }}</div>
    </div>
  </div>
</ng-template>
